import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {AuthType} from '../../shared/constants/AppEnums';
import {AppActions} from '../../types';
import {Dispatch} from 'redux';
import {
  SET_AUTH_TOKEN,
  SIGNOUT_AUTH_SUCCESS,
  UPDATE_AUTH_USER,
} from '../../types/actions/Auth.actions';
import {
  Write,
  Remove,
  Read,
  Token as TokenKey,
  Expire as ExpireKey,
  Language as LanguageKey,
  ActiveRole as ActiveRoleKey,
} from '../../utils/localstorage';
import {AuthUser} from 'types/models/AuthUser';

export const onJwtSignIn = (body: {email: string; password: string}) => {
  const language = Read(LanguageKey)?.languageId === 'Persian' ? 'FA' : 'EN';
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      let apiBody = {
        username: body.email,
        password: body.password,
        language: language,
      };
      // const res = await jwtAxios.post('authentication', apiBody);
      await jwtAxios.post('authentication', apiBody).then((response: any) => {
        response = response?.data?.Data;
        Write(TokenKey, response.Token);
        Write(ExpireKey, (Date.now() + 1000 * 60 * 60 * 10).toString());
        dispatch(setJWTToken(response.Token));
        dispatch({
          type: UPDATE_AUTH_USER,
          payload: getUserObject(AuthType.JWT_AUTH, response),
        });
        dispatch(
          fetchSuccess(
            'Welcome ' + response.Firstname + ' ' + response.Lastname,
          ),
        );
      });
    } catch (err) {
      dispatch(fetchError(err?.response?.data?.Message ?? ''));
    }
  };
};

export const loadJWTUser = () => {
  const language = Read(LanguageKey)?.languageId === 'Persian' ? 'FA' : 'EN';
  const initialToken = Read(TokenKey);

  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    dispatch(setJWTToken(initialToken));
    try {
      await jwtAxios
        .get(`authentication?lang=${language}`)
        .then((response: any) => {
          response = response.data.Data;
          dispatch(fetchSuccess());
          dispatch({
            type: UPDATE_AUTH_USER,
            payload: getUserObject(AuthType.JWT_AUTH, response),
          });
        });
    } catch (err) {
      dispatch(fetchError(err?.response?.data?.Message ?? ''));
    }
  };
};

export const setJWTToken = (token: string | null): AppActions => ({
  type: SET_AUTH_TOKEN,
  payload: token,
});

const getUserObject = (authType: any, authUser: any): AuthUser => {
  return {
    authType: authType,
    displayName: authUser.Firstname + ' ' + authUser.Lastname,
    email: authUser.Email,
    mobile: authUser.Mobile,
    role: ['user'],
    uid: '123',
    photoURL: authUser.Image,
    hasChangedPassword: authUser.HasChangedPassword,
    gender: authUser.Sex,
    menu: JSON.parse(authUser.MenuForms),
    credit: authUser.Credit,
    balance: authUser.Balance,
    currency: authUser.CurrencyID,
  };
};

export const onJWTAuthSignout = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchSuccess());
    setTimeout(() => {
      dispatch({type: SIGNOUT_AUTH_SUCCESS});
      dispatch(fetchSuccess());
      Remove(TokenKey);
      Remove(ExpireKey);
      Remove(ActiveRoleKey);
    }, 500);
  };
};
